export function getMaxWidth(isBigScreen: boolean) {
  return isBigScreen ? '100vw' : '5vw'
}
